import React from 'react';
import { useI18nContext } from '../../../context/language/use-i18n-context';
import { useUserContext } from '../../../context/user';
import { AppConfig } from '../../../utils/constants';
import styles from './legaltext-banner.module.css';
import { Languages } from 'models/translations';
import { PassPolicy } from '../../../models/IPassPolicy';

const legalText = {
  english: [
    'Guest Pass is not intended for employees and is not subject to employment income tax.',
    'If a Guest Pass is issued to an employee, it is a violation of the company policy, and the employee will be responsible for any income tax risk associated with the policy violation.',
  ],
  korean: [
    'Guest Pass는 직원에게 발급되는 패스가 아니므로 근로소득세 부과 대상이 아닙니다.',
    '만약 Guest Pass가 직원에게 발급된다면, 이는 회사 규정 위반이며, 이로 인한 소득세 위험은 직원의 책임입니다.',
  ],
};

interface LegalTextBannerProps {
  className?: string;
  testId?: string;
  passPolicy?: PassPolicy;
}

export const LegalTextBanner: React.FC<LegalTextBannerProps> = ({
  className = '',
  testId = 'legal-text-banner',
  passPolicy,
}) => {
  const lngContext = useI18nContext();
  const userInfo = useUserContext();

  if (userInfo?.passplayUser?.userLocationId !== AppConfig.policyLocationIds.korea) {
    return null;
  }

  if (userInfo?.passplayUser?.userLocationId === AppConfig.policyLocationIds.korea) {
    if (passPolicy?.selfInviteOnly === true) {
      return null;
    }
  }

  const displayText =
    lngContext.currentLanguage.tag === Languages.KO ? legalText.korean : legalText.english;

  return (
    <div className={`${styles.legalTextBanner} ${className}`} data-testid={testId}>
      <div className={styles.legalTextContent}>
        {displayText.map((text, index) => (
          <p key={index}>{text}</p>
        ))}
      </div>
    </div>
  );
};

export default LegalTextBanner;
